<template>
  <div class="declaracao-cadastro">
    <Dialog :visible.sync="showCadastro" :modal="true" :closable="false">
      <h1 class="titulo-header">
        {{ damAvulso ? 'Novo DAM Avulso' : 'Nova Declaração' }}
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="closeCadastro()"
        />
      </h1>
      <div id="topo" class="scrolable-dialog">
        <error-list :erros="erros" />
        <div v-if="showOrientacoes">
          <span class="navigation" style="font-weight:bold">Orientações:</span><br />
          <div v-html="msgInformacao"></div>
          <hr />
        </div>

        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="descServico">Ano:</label>
            <span class="p-fluid">
              <InputMask
                v-model="declaracao.ano"
                :disabled="
                  !(this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E')
                "
                mask="9999"
                :autoClear="false"
              />
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="descServico">Mês:</label>
            <span class="p-fluid">
              <InputMask
                v-model="declaracao.mes"
                :disabled="
                  !(this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E')
                "
                mask="99"
                :autoClear="false"
              />
            </span>
          </div>
        </div>

        <div v-if="lblTela === 'Simplificada'" class="row">
          <div class="col-md-2 mb-2">
            <label v-if="exibirAracruz" for="descServico">Número Nota: *</label>
            <label v-if="!exibirAracruz" for="descServico">Número Nota:</label>
            <span class="p-fluid">
              <InputText v-model="declaracao.numeroNota" />
            </span>
          </div>

          <div class="d-flex justify-content-left align-items-end">
            <div class="col-md-4 mb-3">
              <label for="tipoContribuinte">Tipo Documento:</label>
              <Dropdown
                id="tipoContribuinte"
                v-model="selectedTipoContribuinte"
                :options="tiposContribuinte"
                optionLabel="name"
                placeholder="Selecione um Tipo"
                class="inputLogin"
                @change="limparDocumento()"
              />
            </div>

            <div class="col-md-5 mb-3">
              <label for="documento">
                Documento Tomador:
                <!-- {{ selectedTipoContribuinte && selectedTipoContribuinte.key == "J" ? "CNPJ:" : "CPF:" }} -->
              </label>
              <span class="p-fluid" style="margin-right: 60px">
                <InputMask
                  id="documento"
                  v-model="declaracao.documentoTomador"
                  :mask="mascaraDocumento"
                  :placeholder="placeholderDocumento"
                  :key="selectedTipoContribuinte ? selectedTipoContribuinte.key : 'F'"
                  class="inputLogin"
                  style="text-transform: uppercase;"
                />
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8 mb-2">
            <label for="tipo">Tipo:</label>
            <span class="p-fluid">
              <Dropdown
                id="tipo"
                name="tipo"
                v-model="selectedTipo"
                :options="tipos"
                optionLabel="name"
                placeholder="Selecione um Tipo"
              />
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="servico">Serviço: *</label>
            <span class="p-fluid">
              <AutoComplete
                id="servico"
                v-model="selectedServico"
                :dropdown="true"
                :suggestions="filteredServicos"
                field="detail"
                placeholder="Pesquisar"
                @complete="searchServico($event)"
                @item-select="atualizarDadosTela()"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="valorServico">Valor Serviço: *</label>
            <span class="p-fluid">
              <money
                id="valorServico"
                name="valorServico"
                v-model="declaracao.valorServico"
                v-bind="money"
                class="p-inputtext input-right"
              ></money>
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="aliquota">Alíquota: *</label>
            <span class="p-fluid">
              <money
                id="aliquota"
                name="aliquota"
                v-model="declaracao.aliquota"
                v-bind="percent4"
                class="p-inputtext input-right"
                :disabled="desabilitarAliquota"
              ></money>
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="deducao">Dedução:</label>
            <span class="p-fluid">
              <money
                id="deducao"
                name="deducao"
                v-model="declaracao.valorDesconto"
                v-bind="money"
                class="p-inputtext input-right"
                :disabled="desabilitarDeducao"
              ></money>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="descServico">Observação: *</label>
            <span class="p-fluid">
              <textarea id="descServico" name="descServico" v-model="declaracao.observacao" rows="5" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label v-if="showMessageSimoes || showMessageRioClaro" for="file">Anexar abaixo a Nota Fiscal: * </label>
            <label v-else for="file">Selecionar abaixo um arquivo, caso queira anexar ao registro: </label>
            <br />
            <Button
              class="p-button-primary mr-2"
              icon="pi pi-plus"
              @click="openFileInput()"
              :label="selectedFilesFormatado.length == 0 ? 'Selecionar Arquivo' : 'Adicionar Arquivo'"
              type="button"
            />
            <input
              style="display: none;"
              class="button-arquivo"
              placeholder="Adicionar Arquivo"
              type="file"
              id="files"
              ref="files"
              v-on:change="handleFileUploads()"
            />
          </div>
        </div>

        <div v-if="selectedFilesFormatado.length != 0" class="row">
          <div class="col-md-10 mb-2">
            <DataTable
              :value="selectedFilesFormatado"
              :paginator="true"
              :rows="5"
              :autoLayout="true"
              style="min-width: 100%; text-align: center"
            >
              <Column headerStyle="width: 1%">
                <template #body="rowData">
                  <Button
                    class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times"
                    label="Remover"
                    @click="removeFile(rowData)"
                  />
                </template>
              </Column>
              <Column field="name" header="Nome do Arquivo"></Column>
              <Column field="size" header="Tamanho do Arquivo"></Column>
              <Column field="type" header="Tipo do Arquivo"></Column>
            </DataTable>
          </div>
        </div>
        <hr />
      </div>

      <div class="botoes-avancar-voltar">
        <Button
          @click="salvar()"
          href="#topo"
          type="button"
          label="Gravar"
          class="p-button-primary mr-2 p-button-success"
          icon="pi pi-check"
          :disabled="loading"
        />
        <Button
          @click="closeCadastro()"
          type="button"
          label="Fechar"
          class="p-button-primary mr-2 p-button-danger"
          icon="pi pi-times"
        />
      </div>
    </Dialog>
  </div>
</template>

<script>
import money from '../conf/config.money';
import percent from '../conf/config.percent';
import percent4 from '../conf/config.percent4';
import LoginService from '../services/acesso/login.service';
import Declaracao from '../models/tributario/Declaracao';
import ContribuinteServicoService from '../services/tributario/contribuinte.servico.service';
import DeclaracaoSimplificada from '../services/tributario/declaracao.simplificada.service';
import DeclaracaoCartorio from '../services/tributario/declaracao.cartorio.service';
import usuarioAcessoCampoService from '../services/nfse/usuario.acesso.campo.service';
import Vue from 'vue';
import { CLIENT_ID } from '../Utils/clienteId';

export default {
  name: 'DeclaracaoSimplificadaCadastro',

  data() {
    return {
      money: money,
      percent: percent,
      percent4: percent4,
      loading: false,
      erros: [],
      showCadastro: false,
      currentUser: null,
      declaracao: new Declaracao(),
      selectedServico: null,
      filteredServicos: [],
      showOrientacoes: false,
      damAvulso: false,
      lblTela: 'Simplificada',
      files: '',
      selectedFilesFormatado: [],
      selectedFiles: [],
      msgInformacao: null,
      habilitaAliquotaOptanteSs: null,
      showMessageSimoes: false,
      showMessageRioClaro: false,
      selectedTipo: null,
      tipos: [
        { name: 'ISS Próprio', key: 'Normal' },
        { name: 'Retido', key: 'Retido' },
      ],
      tiposContribuinte: [
        { name: 'Pessoa Física (CPF)', key: 'cpf' },
        { name: 'Pessoa Jurídica (CNPJ)', key: 'cnpj' },
      ],
      documento: '',
      selectedTipoContribuinte: null,
      exibirAracruz: false,
      permissoesCampos: {},
      desabilitarDeducao: false,
      desabilitarAliquota: false,
      idSimoesFilho: CLIENT_ID.SIMOES_FILHO,
      idRioClaro: CLIENT_ID.RIO_CLARO,
      idAracruz: CLIENT_ID.ARACRUZ,
    };
  },

  created() {
    this.$root.$on('declaracaoSimplificada:novo', ({ damAvulso }) => {
      this.damAvulso = damAvulso;
      this.novo();
      this.selectedTipo = this.tipos[0];
      this.carregarPermissoesCampos();
    });

    if (this.$router.currentRoute.path === '/declaracaoCartorio') {
      this.lblTela = 'Cartório';
    }

    this.currentUser = LoginService.currentUserValue;
    this.msgInformacao = this.currentUser.configuracao.msgDecSimplificada;
    this.showOrientacoes = false;
    if (this.msgInformacao) {
      this.showOrientacoes = true;
    }

    this.desabilitarEdicaoAliquotaOptante();
    this.openMessageSimoes();
    this.openMessageRioClaro();

    if (this.currentUser.usuario.idCliente === '1f951e4d-d692-4ff8-8236-429b1306b4a8') {
      this.exibirAracruz = true;
    } else {
      this.exibirAracruz = false;
    }

    if (this.currentUser.usuario.idCliente === '19533831040781681800D2584C905F8A') {
      this.desabilitarDeducao = true;
    }

    this.currentUser.configuracao.idBolDesabAlqDecSimplificada === 'S'
      ? (this.desabilitarAliquota = true)
      : (this.desabilitarAliquota = false);
  },

  mounted() {
    this.selectedTipoContribuinte = this.tiposContribuinte[0];
  },

  methods: {
    novo() {
      this.showCadastro = true;
      this.erros = [];
      this.declaracao.ano = this.$parent.filtroAno.key;
      this.declaracao.mes = String(this.$parent.filtroMes.key)
        .trim()
        .padStart(2, '0');
      this.declaracao.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.declaracao.idUsuario = this.currentUser.usuario.idUsuario;
      this.declaracao.idCliente = this.currentUser.usuario.idCliente;
      this.declaracao.valorServico = 0;
      this.declaracao.valorDesconto = 0;
      this.declaracao.aliquota = 0;
      this.declaracao.observacao = '';
      this.selectedServico = null;
    },
    searchServico(event) {
      setTimeout(async () => {
        this.filteredServicos = await ContribuinteServicoService.findAllNfAvulsa(
          event.query,
          this.currentUser.contribuinte.idContribuinte,
        );
      }, 250);
    },
    atualizarDadosTela() {
      this.processando(true);
      this.declaracao.aliquota = 0;
      this.declaracao.idServicoItem = null;
      if (this.selectedServico && this.selectedServico.idServico && this.selectedServico.idServico.idServicoItem) {
        this.declaracao.aliquota = this.selectedServico.idServico.valorAliquota;
        this.declaracao.idServicoItem = this.selectedServico.idServico.idServicoItem;
      }
      this.processando(false);
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        if (!(file instanceof Blob)) {
          reject(new Error('O parâmetero fornecido não é do tipo Blob'));
          return;
        }
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
        reader.onerror = (error) => reject(error);
      });
    },
    openFileInput() {
      this.$refs.files.click();
    },
    handleFileUploads() {
      this.files = this.$refs.files.files;
      const maxFiles = 5;
      let selectedCount = this.selectedFiles.length;

      for (const file of this.files) {
        const fileSizeInKB = file.size / 1024;
        const fileSizeDisplay =
          fileSizeInKB < 1024 ? `${fileSizeInKB.toFixed(0)} Kb` : `${(fileSizeInKB / 1024).toFixed(0)} MB`;
        if (fileSizeInKB > 1024 * 20) {
          this.$root.$emit(
            'alert:warn',
            `O arquivo '${file.name}' ultrapassa o limite de 20 MB e não pode ser selecionado.`,
          );
        } else {
          if (selectedCount < maxFiles) {
            if (!this.isFileSelected(file.name)) {
              this.selectedFilesFormatado.push({
                name: file.name,
                size: fileSizeDisplay,
                type: this.getFileType(file.type),
              });

              console.log(file.type);
              this.selectedFiles.push(file);
              selectedCount++;
            } else {
              this.$root.$emit('alert:warn', `O arquivo '${file.name}' já está selecionado.`);
            }
          } else {
            this.$root.$emit('alert:warn', `Você atingiu o limite máximo de ${maxFiles} arquivos selecionados.`);
            break;
          }
        }
      }

      this.$refs.files.value = '';
    },
    isFileSelected(fileName) {
      return this.selectedFiles.some((file) => file.name === fileName);
    },
    removeFile(fileToRemove) {
      console.log(fileToRemove);
      console.log(fileToRemove.data.name);

      const clearFileName = fileToRemove.data.name.trim().toLowerCase();

      const indexFormatado = this.selectedFilesFormatado.findIndex(
        (file) => file.name.trim().toLowerCase() === clearFileName,
      );
      const index = this.selectedFiles.findIndex((file) => file.name.trim().toLowerCase() === clearFileName);
      if (index !== -1 && indexFormatado !== -1) {
        this.selectedFilesFormatado.splice(indexFormatado, 1);
        this.selectedFiles.splice(index, 1);

        if (this.selectedFiles.length === 0 && this.selectedFilesFormatado.length === 0) {
          this.$refs.files.value = '';
        }
      }
    },
    getFileType(fileType) {
      const fileExtension = fileType
        .split('/')
        .pop()
        .toLowerCase();

      switch (fileExtension) {
        case 'pdf':
          return 'PDF';
        case '':
          return 'Rar';
        case 'xml':
          return 'Xml';
        case 'vnd.ms-excel':
          return 'XLS (EXCEL)';
        case 'txt':
          return 'Txt';
        case 'x-zip-compressed':
          return 'Zip';
        case 'csv':
          return 'Csv';
        default:
          return 'Outro';
      }
    },
    salvar() {
      let msg = null;
      this.declaracao.tipo = this.selectedTipo.key;
      if (this.currentUser.usuario.idCliente === this.idAracruz && this.lblTela != 'Cartório') {
        if (!this.declaracao.numeroNota) {
          msg = 'É necessário preencher o campo Número Nota!';
        }
        if (!this.declaracao.documentoTomador) {
          msg = 'É necessário preencher o campo Documento Tomador!';
        }
      }
      if ((this.showMessageSimoes || this.showMessageRioClaro) && this.selectedFiles.length === 0) {
        msg = 'É obrigatório anexar a Nota Fiscal para prosseguir.';
      }
      this.erros.splice(0, this.erros.length);
      if (!msg) {
        if (this.selectedFiles.length > 0) {
          this.processando(true);

          Promise.all(
            this.selectedFiles.map(async (file) => {
              try {
                let base64 = await this.getBase64(file);
                this.declaracao.anexos.push({
                  file: base64,
                  nomeArquivo: file.name,
                  tipoArquivo: file.type,
                });
              } catch (error) {
                console.log('Erro ao converter arquivo para base64');
                this.erros.push('Erro ao processar arquivo.');
              }
            }),
          ).then(() => {
            if (this.lblTela == 'Simplificada') {
              DeclaracaoSimplificada.salvar(this.declaracao)
                .then(
                  (response) => {
                    console.log(response);
                    console.log(this.declaracao);
                    this.$parent.pesquisar();
                    this.$root.$emit(
                      'alert:success',
                      this.damAvulso ? 'DAM Avulso realizado com sucesso!' : 'Declaração realizada com sucesso!',
                    );
                    this.closeCadastro();
                  },
                  (error) => {
                    let errorMessage = 'Houve um problema ao gerar a Declaração Simplificada!';
                    if (error.response) {
                      const errors = Array.isArray(error.response.data) ? error.response.data : [error.response.data];

                      errors.forEach((err) => {
                        this.$toast.add({
                          severity: 'error',
                          summary: 'Erro',
                          detail: err,
                          life: 5000,
                        });
                      });
                    } else {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: errorMessage,
                        life: 5000,
                      });
                    }
                  },
                )
                .then(() => {
                  this.processando(false);
                });
            } else {
              DeclaracaoCartorio.salvar(this.declaracao)
                .then(
                  (response) => {
                    console.log(response);
                    console.log(this.declaracao);
                    this.$parent.pesquisar();
                    this.$root.$emit(
                      'alert:success',
                      this.damAvulso ? 'DAM Avulso realizado com sucesso!' : 'Declaração realizada com sucesso!',
                    );
                    this.closeCadastro();
                  },
                  (error) => {
                    let errorMessage = 'Houve um problema ao gerar a Declaração Cartório!';
                    if (error.response) {
                      const errors = Array.isArray(error.response.data) ? error.response.data : [error.response.data];

                      errors.forEach((err) => {
                        this.$toast.add({
                          severity: 'error',
                          summary: 'Erro',
                          detail: err,
                          life: 5000,
                        });
                      });
                    } else {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: errorMessage,
                        life: 5000,
                      });
                    }
                  },
                )
                .then(() => {
                  this.processando(false);
                });
            }
          });
        } else {
          this.processando(true);
          if (this.lblTela == 'Simplificada') {
            DeclaracaoSimplificada.salvar(this.declaracao)
              .then(
                (response) => {
                  console.log(response);
                  this.$parent.pesquisar();
                  this.$root.$emit(
                    'alert:success',
                    this.damAvulso ? 'DAM Avulso realizado com sucesso!' : 'Declaração realizada com sucesso!',
                  );
                  this.closeCadastro();
                },
                (error) => {
                  let errorMessage = 'Houve um problema ao gerar a Declaração Simplificada!';
                  if (error.response) {
                    const errors = Array.isArray(error.response.data) ? error.response.data : [error.response.data];

                    errors.forEach((err) => {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: err,
                        life: 5000,
                      });
                    });
                  } else {
                    this.$toast.add({
                      severity: 'error',
                      summary: 'Erro',
                      detail: errorMessage,
                      life: 5000,
                    });
                  }
                },
              )
              .then(() => {
                this.processando(false);
              });
          } else {
            DeclaracaoCartorio.salvar(this.declaracao)
              .then(
                (response) => {
                  console.log(response);
                  this.$parent.pesquisar();
                  this.$root.$emit(
                    'alert:success',
                    this.damAvulso ? 'DAM Avulso realizado com sucesso!' : 'Declaração realizada com sucesso!',
                  );
                  this.closeCadastro();
                },
                (error) => {
                  let errorMessage = 'Houve um problema ao gerar a Declaração Cartório!';
                  if (error.response) {
                    const errors = Array.isArray(error.response.data) ? error.response.data : [error.response.data];

                    errors.forEach((err) => {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: err,
                        life: 5000,
                      });
                    });
                  } else {
                    this.$toast.add({
                      severity: 'error',
                      summary: 'Erro',
                      detail: errorMessage,
                      life: 5000,
                    });
                  }
                },
              )
              .then(() => {
                this.processando(false);
              });
          }
        }
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    closeCadastro() {
      this.selectedFiles = [];
      this.selectedFilesFormatado = [];
      this.files = '';
      this.declaracao.anexos = [];
      this.showCadastro = false;
    },
    desabilitarEdicaoAliquotaOptante() {
      DeclaracaoSimplificada.editarAliquota(this.currentUser.contribuinte.idContribuinte).then(
        (data) => {
          this.habilitaAliquotaOptanteSs = data.data.desabilitarEdicaoAliquota;
        },
        (error) => {
          let errorMessage = 'Não foi possível buscar um contribuinte!';
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
    },
    openMessageSimoes() {
      if (this.currentUser.usuario.idCliente == this.idSimoesFilho) {
        this.showMessageSimoes = true;
      } else {
        this.showMessageSimoes = false;
      }
    },
    openMessageRioClaro() {
      if (this.currentUser.usuario.idCliente == this.idRioClaro) {
        this.showMessageRioClaro = true;
      } else {
        this.showMessageRioClaro = false;
      }
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },
    async carregarPermissoesCampos() {
      const usuarioId = this.currentUser.usuario.idUsuario;
      const nomesCampos = ['Dedução'];

      try {
        this.permissoesCampos = {};

        for (const nomeCampo of nomesCampos) {
          const response = await usuarioAcessoCampoService.buscarPermissoesCamposPorNomes(usuarioId, nomeCampo);

          if (response.data !== undefined && response.data !== null) {
            console.log(`Permissão para ${nomeCampo}:`, response.data);
            Vue.set(this.permissoesCampos, nomeCampo, response.data);
          } else {
            console.log(`Permissão para ${nomeCampo}: Nenhum registro encontrado, habilitando por padrão`);
            Vue.set(this.permissoesCampos, nomeCampo, true);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar permissões dos campos:', error);
        Vue.set(this.permissoesCampos, 'Dedução', true);
      }
    },
    limparDocumento() {
      this.declaracao.documentoTomador = '';
    },
  },

  computed: {
    mascaraDocumento() {
      if (this.selectedTipoContribuinte && this.selectedTipoContribuinte.key === 'cnpj') {
        return '**.***.***/****-99';
      }
      return '999.999.999-99';
    },
    placeholderDocumento() {
      if (this.selectedTipoContribuinte && this.selectedTipoContribuinte.key === 'cnpj') {
        return '__.___.___/____-__';
      }
      return '___.___.___-__';
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

textarea {
  width: 100%;
  border-radius: 12px;
}

.inputLogin {
  border-radius: 12px;
}
</style>
